
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link,Tracking } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Während Roger Federer nach eigenen Angaben oft elf Stunden schläft, kommen andere scheinbar mit viel weniger aus. Margaret Thatcher sollen fünf Stunden Schlaf gereicht haben, Apple-Chef Tim Cook hat sich bereits öfter als notorischer Wenigschläfer geoutet, und der Uhren-Manager Jean-Claude Biver gibt an, um 4 Uhr morgens mit der Arbeit zu beginnen, um zwei Stunden Vorsprung auf die Konkurrenz zu haben. Kann ein Mensch wirklich so wenig schlafen, ohne im Alltag regelmässig durchzudrehen? `}<M mdxType="M">{`Tatsächlich gibt es genetisch bedingt Kurzschläfer, die schon nach fünf Stunden Schlaf wieder fit sind und sich gut konzentrieren können.`}</M>{` `}<br /><br />{`
Für die meisten Menschen gilt das aber nicht. Für sie hat zu wenig Nachtruhe weitreichende Folgen. Der Arbeitspsychologe Theo Wehner sagt es so: Wer eine Woche lang jede Nacht markant zu wenig schlafe oder einmalig 24 Stunden am Stück wach bleibe, sei danach in gleichem Masse eingeschränkt wie ein Ausgeschlafener mit 1,0 Promille Alkohol im Blut. `}<br /><br />{`
Auch mehrere Studien bestätigen diese Erkenntnis. Kanadische Wissenschaftler haben 2018 das Schlafverhalten von über `}<Link href='https://academic.oup.com/sleep/article/41/12/zsy182/5096067' mdxType="Link">{`10’000 Personen untersucht.`}</Link>{` Die Teilnehmer wurden nach ihrer individuellen Schlafzeit befragt. Anschliessend mussten sie sich einem umfangreichen Onlinetest unterziehen. Überprüft wurden unter anderem logisches Denken, die Erinnerungskraft und verbale Fähigkeiten. `}<M mdxType="M">{`Es zeigte sich, dass Übermüdete (und auch Langschläfer!) fahriger sprechen und schlechtere Entscheidungen treffen.`}</M></p>
    <Tracking label='content75' mdxType="Tracking" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;